import React, { useMemo, useState } from "react";

// Every actual settlement (outstanding_adjusted entry) across the whole
// vendor, in one flat chronological list — separate from the Debt Summary
// table above, which is organized by debt instead of by payment. This is
// "show me every payment that happened," full stop.
const VendorLedgerPaymentsList = ({ entries }) => {
  const [collapsed, setCollapsed] = useState(true);

  const payments = useMemo(
    () =>
      entries
        .filter((e) => e.type === "outstanding_adjusted")
        .sort((a, b) => b.id - a.id),
    [entries],
  );

  if (payments.length === 0) return null;

  const total = payments.reduce((s, p) => s + Number(p.amount || 0), 0);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 mb-6">
      <button
        type="button"
        onClick={() => setCollapsed((v) => !v)}
        className="flex items-center justify-between w-full text-left"
      >
        <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">
          All Payments — {payments.length} settlement{payments.length !== 1 ? "s" : ""},{" "}
          <span className="text-green-700">₹{total}</span> total adjusted
        </p>
        <span className="text-xs text-green-700 font-semibold whitespace-nowrap ml-3">
          {collapsed ? "Show ▼" : "Hide ▲"}
        </span>
      </button>

      {!collapsed && (
        <div className="overflow-x-auto mt-3">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-gray-50 dark:bg-gray-700/40 text-gray-500 dark:text-gray-400 text-left">
                <th className="px-3 py-2 whitespace-nowrap">Date</th>
                <th className="px-3 py-2">Settled From (Debt)</th>
                <th className="px-3 py-2">Settled Into (Booking)</th>
                <th className="px-3 py-2 whitespace-nowrap">Amount</th>
                <th className="px-3 py-2">Payment Method</th>
                <th className="px-3 py-2">Remark</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p) => (
                <tr key={p.id} className="border-t border-gray-100 dark:border-gray-700">
                  <td className="px-3 py-2 whitespace-nowrap text-gray-500">{p.date}</td>
                  <td className="px-3 py-2 font-semibold text-red-700">
                    {p.resolved_from?.ref_no || "—"}
                  </td>
                  <td className="px-3 py-2 font-semibold text-green-700">
                    {p.ref_no || "—"}
                    {p.client_name && (
                      <span className="text-gray-400 font-normal"> ({p.client_name})</span>
                    )}
                  </td>
                  <td className="px-3 py-2 font-semibold whitespace-nowrap">₹{p.amount}</td>
                  <td className="px-3 py-2 whitespace-nowrap">
                    {p.payment_type ? (
                      <>
                        {p.payment_type}
                        {p.utr ? ` · UTR ${p.utr}` : ""}
                      </>
                    ) : (
                      <span className="text-amber-600">not on record</span>
                    )}
                  </td>
                  <td className="px-3 py-2">
                    {p.description}
                    {p.remark && <div className="text-gray-400">— {p.remark}</div>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VendorLedgerPaymentsList;
